import { render, staticRenderFns } from "./CredentialsForm.vue?vue&type=template&id=3cdff81c&"
import script from "./CredentialsForm.vue?vue&type=script&lang=js&"
export * from "./CredentialsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports